import React, { useEffect } from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { FLOWS_ENUM } from '../../common/enums';
import Success from '../../components/payment/common/success/Success';
import AdminUpdateSuccessFields from '../../components/payment/common/success/AdminUpdateSuccessFields';
import { useDispatch } from 'react-redux';
import { resetAdminUpdateState } from '../../store/slices/adminUpdate/adminUpdateSlice';

const AdminUpdateSuccess = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetAdminUpdateState());
  }, [dispatch]);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader
          flow={FLOWS_ENUM.ADMIN_UPDATE}
          showAccountDropdown={false}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as="main"
        id="main-content"
        tabIndex={-1}
        colspan={24}
        aria-label="Admin update submitted"
      >
        <Content as="div">
          <Success
            successComponent={() => <AdminUpdateSuccessFields />}
            showReturnToDashboardButton={false}
            flow={FLOWS_ENUM.ADMIN_UPDATE}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default AdminUpdateSuccess;
